export default __webpack_public_path__ + "static/media/3.f48a66c7.jpg";